// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__CgD4r","list":"BalanceDue_list__2p6yU","listRow":"BalanceDue_listRow__sBncQ","total":"BalanceDue_total__3TmxG"};